(function () {
  var CM = 2.54;
  var unit = 'in';

  function convert(value, from, to) {
    var n = from === to ? value : (to === 'cm' ? value * CM : value / CM);
    return String(Math.round(n * 10) / 10);
  }

  function label(key) {
    return key.replace(/[_-]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function selectedSize(chart) {
    var sizes = chart.sizes.map(function (s) { return String(s.size).toLowerCase(); });
    var found = null;
    document.querySelectorAll('[data-product-option-group]').forEach(function (group) {
      var el = group.querySelector('.main-product__variant.is-selected, [aria-pressed="true"][data-product-option-value]');
      var val = el ? el.getAttribute('data-product-option-value') : null;
      if (val === null) {
        var sel = group.querySelector('select');
        val = sel ? sel.value : null;
      }
      if (val && sizes.indexOf(val.toLowerCase()) > -1) found = val.toLowerCase();
    });
    return found;
  }

  function render(host) {
    var chart;
    try { chart = JSON.parse(host.getAttribute('data-chart')); } catch (e) { return; }
    if (typeof chart === 'string') { try { chart = JSON.parse(chart); } catch (e) { return; } }
    if (!chart || !chart.sizes || !chart.columns) return;

    var base = chart.unit === 'cm' ? 'cm' : 'in';
    var current = selectedSize(chart);
    var html = '<div class="size-chart__toggle" role="group" aria-label="Units">' +
      ['in', 'cm'].map(function (u) {
        return '<button type="button" data-size-chart-unit="' + u + '" aria-pressed="' + (u === unit) + '"' +
          ' style="margin-right:8px;padding:4px 10px;border:1px solid currentColor;color:inherit;cursor:pointer;background:' +
          (u === unit ? 'rgba(128,128,128,.25)' : 'transparent') + ';font-weight:' + (u === unit ? '700' : '400') + '">' + u + '</button>';
      }).join('') + '</div>';

    html += '<table class="size-chart__table" style="width:100%;margin-top:16px;border-collapse:collapse;text-align:left"><thead><tr><th style="padding:8px 6px">Size</th>' +
      chart.columns.map(function (c) { return '<th style="padding:8px 6px">' + label(c) + ' (' + unit + ')</th>'; }).join('') +
      '</tr></thead><tbody>' +
      chart.sizes.map(function (row) {
        var on = current && String(row.size).toLowerCase() === current;
        return '<tr' + (on ? ' class="is-current" aria-current="true" style="font-weight:700;background:rgba(128,128,128,.18)"' : '') + '>' +
          '<td style="padding:8px 6px;border-top:1px solid rgba(128,128,128,.4)">' + row.size + '</td>' +
          chart.columns.map(function (c) {
            var v = Number(row[c]);
            var out = isNaN(v) ? (row[c] == null ? '' : row[c]) : convert(v, base, unit);
            return '<td style="padding:8px 6px;border-top:1px solid rgba(128,128,128,.4)">' + out + '</td>';
          }).join('') + '</tr>';
      }).join('') + '</tbody></table>';

    host.innerHTML = html;
    host.querySelectorAll('[data-size-chart-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        unit = b.getAttribute('data-size-chart-unit');
        render(host);
      });
    });
  }

  function renderAll() {
    document.querySelectorAll('[data-size-chart]').forEach(render);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-size-guide-open]')) renderAll();
  });
  renderAll();
})();
